import cx from "classnames";
import styles from "./BreadcrumbScrollCX.module.css";
import Link from "next/link";
import { useDetectScroll } from "@smakss/react-scroll-direction";
import HomeIcon from "@mui/icons-material/Home";

const BreadcrumbScrollCX = ({
  title,
  routeOne,
  titleOne,
  routeTwo,
  titleTow,
}) => {
  const [scrollDir] = useDetectScroll({});

  return (
    <div
      className={cx(
        styles.container,
        "d-flex",
        "align-items-center",
        "justify-content-between",
        scrollDir !== "down" ? styles.Stick : styles.notStick
      )}
    >
      <h3 className={cx(styles.titleStyles, "d-none", "d-xxl-flex")}>
        {title?.length > 70 ? `${title?.slice(0, 71)} ...` : title}
      </h3>
      <h3
        className={cx(styles.titleStyles, "d-none", "d-xl-flex", "d-xxl-none")}
      >
        {title?.length > 60 ? `${title?.slice(0, 61)} ...` : title}
      </h3>
      <h3
        className={cx(styles.titleStyles, "d-none", "d-lg-flex", "d-xl-none")}
      >
        {title?.length > 40 ? `${title?.slice(0, 41)} ...` : title}
      </h3>
      <h3
        className={cx(styles.titleStyles, "d-none", "d-md-flex", "d-lg-none")}
      >
        {title?.length > 50 ? `${title?.slice(0, 51)} ...` : title}
      </h3>
      <h3
        className={cx(styles.titleStyles, "d-none", "d-sm-flex", "d-md-none")}
      >
        {title?.length > 40 ? `${title?.slice(0, 41)} ...` : title}
      </h3>
      <h3 className={cx(styles.titleStyles, "d-flex", "d-sm-none")}>
        {title?.length > 30 ? `${title?.slice(0, 31)} ...` : title}
      </h3>
      <div className="d-flex align-items-center justify-content-center">
        <span className={cx(styles.verticalLine, "d-flex")}></span>
        <Link className={cx(styles.linkStyle, "d-flex", "mb-sm-1", "mb-0")} href="/">
          <HomeIcon
            sx={{
              color: "#9e9e9e",
              fontSize: "16px",
              transform: "translateY(-1px)",
            }}
          />
        </Link>
        {routeOne && titleOne && (
          <>
            <span className={cx(styles.icon)}>
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5 9L1 5" stroke="#9E9E9E" strokeLinecap="round" />
                <path d="M5 1L1 5" stroke="#9E9E9E" strokeLinecap="round" />
              </svg>
            </span>
            <Link
              className={cx(
                styles.linkStyle,
                !routeTwo && !titleTow && styles.activeLink,
                "d-flex",
                "d-lg-none"
              )}
              href={routeOne}
            >
              {titleOne?.length > 16
                ? `${titleOne?.slice(0, 15)} ...`
                : titleOne}
            </Link>
            <Link
              className={cx(
                styles.linkStyle,
                !routeTwo && !titleTow && styles.activeLink,
                "d-none",
                "d-lg-flex"
              )}
              href={routeOne}
            >
              {titleOne}
            </Link>
          </>
        )}
        {routeTwo && titleTow && (
          <>
            <span className={cx(styles.icon)}>
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5 9L1 5" stroke="#9E9E9E" strokeLinecap="round" />
                <path d="M5 1L1 5" stroke="#9E9E9E" strokeLinecap="round" />
              </svg>
            </span>
            <Link
              href={routeTwo}
              className={cx(
                styles.linkStyle,
                styles.activeLink,
                "d-none",
                "d-xxl-flex"
              )}
            >
              {titleTow?.length > 25
                ? `${titleTow?.slice(0, 26)} ...`
                : titleTow}
            </Link>
            <Link
              href={routeTwo}
              className={cx(
                styles.linkStyle,
                styles.activeLink,
                "d-flex",
                "d-xxl-none"
              )}
            >
              {titleTow?.length > 10
                ? `${titleTow?.slice(0, 11)} ...`
                : titleTow}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default BreadcrumbScrollCX;
